<template>
  <div class="stepper">
    <!-- {{ sConfig }} -->
    <!-- {{ maxQty }} -->
    <div>
      <el-button type="text" icon="el-icon-remove-outline" circle v-if="!isZero()" :disabled="Number(item.Qty) == 1"
        @click="cmd0" />
      <span class="qty" v-if="!isZero()">{{ Number(item.Qty) }}</span>
      <el-button type="text" icon="el-icon-circle-plus-outline" circle @click="cmd1" />
      <div v-if="gGetDcText(item) && doAmt != 0">
        <span class="tag">折價 {{ doAmt }}元</span>
      </div>

      <div v-if="getStock() != ''">
        <van-tag type="primary" size="large" color="#999">{{ getStock() }}</van-tag>
      </div>
    </div>
  </div>
</template>

<style scoped>
.stepper {
  text-align: center;
  margin: 2rem;
}

.qty {
  font-size: 3rem;
}

.el-button {
  margin: 0 2rem 0 2rem;
  font-size: 2rem;
  color: v-bind(sGetConfig("color2"));
}
</style>

<script>
export default {
  props: {
    item: Object,
    doAmt: Number,
    maxQty: Number || String,
  },
  data() {
    return {};
  },
  methods: {
    getStock() {
      // let maxQty = this.sGetConfig("maxItemQty");
      let stockQty = this.item.StockQty;

      // if (stockQty <= maxQty) return "剩餘 " + stockQty + " 份";
      if (stockQty <= 900) return "剩餘 " + stockQty + " 份";
      else return "";
    },
    isZero() {
      if (this.item.Qty < 1) {
        return true;
      }
      return false;
    },
    cmd0() {
      this.item.Qty--;
    },
    cmd1() {
      this.item.Qty++;
      // let maxQty = this.sGetConfig("maxItemQty");
      let maxQty = this.maxQty;
      let stockQty = this.item.StockQty;
      if (stockQty < maxQty) maxQty = stockQty;
      if (maxQty == 0) return;
      if (this.item.Qty > maxQty) this.item.Qty = maxQty;
    },
  },
};
</script>
